export default "__VITE_ASSET__3a6c55a7__"